export default __webpack_public_path__ + "static/media/magicbricksicon.473391bd.png";